import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import Button from "../button";
import styles from "./style.module.css";

interface LinkEmailPromptModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

/**
 * Предложение привязать email (Telegram Mini App).
 * Mobile: bottom sheet; desktop (768px+): centered dialog.
 */
function LinkEmailPromptModal({ open, onClose, onConfirm }: LinkEmailPromptModalProps) {
  const [animatedOpen, setAnimatedOpen] = useState(false);

  useEffect(() => {
    if (!open) {
      setAnimatedOpen(false);
      return;
    }
    const frame = requestAnimationFrame(() => setAnimatedOpen(true));
    return () => cancelAnimationFrame(frame);
  }, [open]);

  useEffect(() => {
    if (!open) return;

    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };

    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKeyDown);

    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [open, onClose]);

  if (!open || typeof document === "undefined") return null;

  return createPortal(
    <div
      className={`${styles.overlay} ${animatedOpen ? styles.open : ""}`}
      role="presentation"
      onClick={onClose}
    >
      <div
        className={styles.panel}
        role="dialog"
        aria-modal="true"
        aria-labelledby="link-email-prompt-modal-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className={styles.header}>
          <h2 id="link-email-prompt-modal-title" className={styles.title}>
            Укажите Email
          </h2>
          <p className={styles.description}>
            Сможете управлять подпиской на сайте, если не будет доступа к Telegram
          </p>
        </div>
        <div className={styles.actions}>
          <Button label="Привязать" onClick={onConfirm} />
          <Button label="В следующий раз" variant="secondary" onClick={onClose} />
        </div>
      </div>
    </div>,
    document.body
  );
}

export default LinkEmailPromptModal;
